export default {"src":"/_next/static/media/redcard.751deb91.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};